export const colors = {
    "british-motors" : [
        {
          "name": "Stone",
          "hex": "#615a50"
        },
        {
          "name": "Mineral Blue",
          "hex": "#162b46"
        },
        {
          "name": "Rivera Blue",
          "hex": "#20476e"
        },
        {
          "name": "Farina Grey",
          "hex": "#a19f93"
        },
        {
          "name": "Colorado Red",
          "hex": "#a51517"
        },
        {
          "name": "Sandy Beige",
          "hex": "#897968"
        },
        {
          "name": "Iris Blue",
          "hex": "#6c8aa6"
        },
        {
          "name": "Midnight Blue ",
          "hex": "#090c13"
        },
        {
          "name": "Grampian Grey",
          "hex": "#444444"
        },
        {
          "name": "Damask Red",
          "hex": "#9e111a"
        },
        {
          "name": "Laguna Beige",
          "hex": "#d5bd97"
        },
        {
          "name": "Smoke Grey",
          "hex": "#7a877e"
        },
        {
          "name": "Florida Green",
          "hex": "#70bd9b"
        },
        {
          "name": "Chelsea Grey",
          "hex": "#b1a389"
        },
        {
          "name": "Maroon",
          "hex": "#33090b"
        },
        {
          "name": "El Paso Beige",
          "hex": "#998965"
        },
        {
          "name": "Alaskan Blue",
          "hex": "#182327"
        },
        {
          "name": "Spruce Green",
          "hex": "#163a2e"
        },
        {
          "name": "Mist Grey",
          "hex": "#525e5e"
        },
        {
          "name": "Tartan Red",
          "hex": "#921319"
        },
        {
          "name": "Titan Beige",
          "hex": "#775d44"
        },
        {
          "name": "Surf Blue",
          "hex": "#417783"
        },
        {
          "name": "Porcelain Green",
          "hex": "#8a9c74"
        },
        {
          "name": "Dove Grey",
          "hex": "#787167"
        },
        {
          "name": "Signal Red",
          "hex": "#b2181a"
        },
        {
          "name": "Arianca Beige",
          "hex": "#725246"
        },
        {
          "name": "Trafalgar Blue",
          "hex": "#0d212c"
        },
        {
          "name": "Connaught Green",
          "hex": "#0c160e"
        },
        {
          "name": "Rose Taupe",
          "hex": "#423a38"
        },
        {
          "name": "Old English White ",
          "hex": "#d7c7a6"
        },
        {
          "name": "Cumulus Grey",
          "hex": "#757978"
        },
        {
          "name": "Snowberry White",
          "hex": "#e1d1b0"
        },
        {
          "name": "Healey Blue",
          "hex": "#59686f"
        },
        {
          "name": "Bermuda Blue",
          "hex": "#7b9b90"
        },
        {
          "name": "Almond Green",
          "hex": "#334633"
        },
        {
          "name": "Arabian Grey",
          "hex": "#c2bea5"
        },
        {
          "name": "Toga White",
          "hex": "#c2bcae"
        },
        {
          "name": "Florentine Blue",
          "hex": "#214859"
        },
        {
          "name": "Honolulu Blue",
          "hex": "#a5c4be"
        },
        {
          "name": "Glen Green",
          "hex": "#858f6d"
        },
        {
          "name": "Canyon Grey",
          "hex": "#98937e"
        },
        {
          "name": "Fiesta Yellow",
          "hex": "#afb380"
        },
        {
          "name": "Island Blue ",
          "hex": "#203749"
        },
        {
          "name": "Aquamarine",
          "hex": "#537c6e"
        },
        {
          "name": "Tweed Grey",
          "hex": "#5b6153"
        },
        {
          "name": "Mandalay Grey",
          "hex": "#717157"
        },
        {
          "name": "Pale Primrose",
          "hex": "#dfc278"
        },
        {
          "name": "Whitehall Beige",
          "hex": "#9e9682"
        },
        {
          "name": "Danube Blue",
          "hex": "#2f3f3e"
        },
        {
          "name": "Everglade Green",
          "hex": "#193121"
        },
        {
          "name": "Fuscous Brown",
          "hex": "#412e1e"
        },
        {
          "name": "Golden Beige",
          "hex": "#787167"
        },
        {
          "name": "Cosmo Blue ",
          "hex": "#101721"
        },
        {
          "name": "Birch Grey",
          "hex": "#6c6e61"
        },
        {
          "name": "Faun Brown",
          "hex": "#201913"
        },
        {
          "name": "Albatross Beige",
          "hex": "#42312a"
        },
        {
          "name": "Dominican Blue",
          "hex": "#889490"
        },
        {
          "name": "Yukon Grey",
          "hex": "#383934"
        },
        {
          "name": "Paladin Red",
          "hex": "#33090b"
        },
        {
          "name": "Armadillo Beige",
          "hex": "#958574"
        },
        {
          "name": "Sherwood Green",
          "hex": "##292e28"
        },
        {
          "name": "Steel Grey",
          "hex": "#686961"
        },
        {
          "name": "Basilica Blue",
          "hex": "#05172f"
        },
        {
          "name": "British Racing Green",
          "hex": "#1d3621"
        },
        {
          "name": "Carlton Grey",
          "hex": "#1d2120"
        },
        {
          "name": "Sable",
          "hex": "#49342f"
        },
        {
          "name": "Horizon Blue ",
          "hex": "#53716f"
        },
        {
          "name": "British Racing Green Dark",
          "hex": "#0e2a1c"
        },
        {
          "name": "Peat",
          "hex": "#47362c"
        },
        {
          "name": "Police White",
          "hex": "#edecd6"
        },
        {
          "name": "Ice Blue",
          "hex": "#6b8f9d"
        },
        {
          "name": "Cumberland Green",
          "hex": "#436034"
        },
        {
          "name": "Dover Grey",
          "hex": "#6e6f69"
        },
        {
          "name": "Old English White ",
          "hex": "#ddcfb2"
        },
        {
          "name": "Royale Blue",
          "hex": "#071a2a"
        },
        {
          "name": "Saxon Grey",
          "hex": "#252928"
        },
        {
          "name": "Maltese White",
          "hex": "#dfcfae"
        },
        {
          "name": "Chalk Blue",
          "hex": "#4d5154"
        },
        {
          "name": "Deep Green",
          "hex": "#090e08"
        },
        {
          "name": "Pale Ivory",
          "hex": "#ecd29f"
        },
        {
          "name": "Chartreuse Yellow",
          "hex": "#dfcd83"
        }
    ]
}